import React, { ReactElement } from "react";

import Heading from "@atoms/heading/Heading";

import * as styles from "@core/ui/molecules/item-list/ItemList.module.scss";

interface ItemListProps {
  title?: string;
  titleLevel?: number;
  items: string[];
  isOrdered?: boolean;
}

const ItemList = ({ title, items, titleLevel, isOrdered = true }: ItemListProps): ReactElement => {
  const ListTag = isOrdered ? "ol" : "ul";
  const headingLevel = titleLevel ?? 3;

  return (
    <div className={styles.itemList}>
      {title && (
        <Heading level={headingLevel} adoptionClassName={styles.title}>
          {title}
        </Heading>
      )}
      <ListTag className={styles.list}>
        {items.map((item, index) => (
          <li key={index} className={styles.item}>
            {item}
          </li>
        ))}
      </ListTag>
    </div>
  );
};
export default ItemList;
